import { useEffect, useState } from 'react'
import { Upload, FileCheck } from 'lucide-react'
import api from '../api/client'
import SearchableSelect from './SearchableSelect'

// Renderiza um FORMULÁRIO DINÂMICO a partir de `schema` (oferta.campos_schema).
// value = {chave: valor} (controlado) · onChange(novoObj)
// files = {chave: File}  (controlado) · onFile(chave, File|null)
export default function CamposRenderer({ schema = [], value = {}, onChange, files = {}, onFile }) {
  const [fontes, setFontes] = useState({})

  useEffect(() => {
    const urls = [...new Set(schema.filter((c) => c.tipo === 'selecao' && c.fonte).map((c) => c.fonte))]
    urls.forEach((u) => {
      setFontes((prev) => {
        if (prev[u]) return prev
        api.get(`${u}?limit=100`).then((r) => {
          const data = r.data?.data || r.data || []
          setFontes((p) => ({ ...p, [u]: data.map((x) => ({ value: x.id, label: x.nome || x.descricao || x.label || `#${x.id}` })) }))
        }).catch(() => {})
        return prev
      })
    })
  }, [schema])

  if (!schema || schema.length === 0) return null
  const set = (chave, v) => onChange({ ...value, [chave]: v })

  // agrupar por `grupo`
  const grupos = []
  schema.forEach((c) => {
    let g = grupos.find((x) => x.nome === (c.grupo || ''))
    if (!g) { g = { nome: c.grupo || '', campos: [] }; grupos.push(g) }
    g.campos.push(c)
  })

  return (
    <div className="space-y-5">
      {grupos.map((g, gi) => (
        <div key={gi}>
          {g.nome && <p className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-2">{g.nome}</p>}
          <div className="grid sm:grid-cols-2 gap-3">
            {g.campos.map((c) => (
              <Campo key={c.chave} c={c} value={value[c.chave]} onChange={(v) => set(c.chave, v)}
                fonteOpts={c.fonte ? fontes[c.fonte] : null} file={files[c.chave]}
                onFile={(f) => onFile && onFile(c.chave, f)} />
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

function Campo({ c, value, onChange, fonteOpts, file, onFile }) {
  const cls = 'w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400'
  const Label = () => (
    <label className="block text-xs font-medium text-gray-600 mb-1">
      {c.label}{c.obrigatorio && <span className="text-accent-500"> *</span>}
    </label>
  )

  if (c.tipo === 'secao') {
    return <div className="sm:col-span-2 pt-1 border-t border-gray-100"><p className="text-sm font-semibold text-gray-700 mt-2">{c.label}</p></div>
  }

  if (c.tipo === 'arquivo') {
    return (
      <div className="sm:col-span-2">
        <Label />
        <label className={`flex items-center gap-2 border border-dashed rounded-lg px-3 py-2.5 text-sm cursor-pointer transition-colors ${file ? 'border-emerald-300 bg-emerald-50/50 text-emerald-700' : 'border-gray-300 text-gray-500 hover:border-accent-400'}`}>
          {file ? <FileCheck size={16} /> : <Upload size={16} />}
          <span className="truncate flex-1">{file ? file.name : `Enviar arquivo${c.formatos ? ` (${c.formatos.join(', ')})` : ''}`}</span>
          <input type="file" className="hidden"
            accept={c.formatos ? c.formatos.map((f) => '.' + f).join(',') : undefined}
            onChange={(e) => onFile(e.target.files?.[0] || null)} />
        </label>
      </div>
    )
  }

  if (c.tipo === 'selecao') {
    return (
      <div>
        <Label />
        <SearchableSelect value={value ?? ''} onChange={onChange} placeholder="Selecione..."
          options={fonteOpts || (c.opcoes || []).map((o) => ({ value: o, label: o }))} />
      </div>
    )
  }

  if (c.tipo === 'booleano') {
    return (
      <div className="flex items-center gap-2 pt-5">
        <input type="checkbox" checked={!!value} onChange={(e) => onChange(e.target.checked)} className="w-4 h-4 accent-accent-500" />
        <span className="text-sm text-gray-700">{c.label}</span>
      </div>
    )
  }

  const inputType = c.tipo === 'numero' || c.tipo === 'moeda' ? 'number' : c.tipo === 'data' ? 'date' : 'text'
  const ph = c.tipo === 'moeda' ? '0,00' : c.tipo === 'cpf' ? '000.000.000-00' : c.tipo === 'cep' ? '00000-000' : c.tipo === 'telefone' ? '(00) 00000-0000' : ''
  return (
    <div>
      <Label />
      <input type={inputType} value={value ?? ''} onChange={(e) => onChange(e.target.value)} className={cls} placeholder={ph} />
    </div>
  )
}
